module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "PrelimTitle"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _vm._v("ADDITIONAL PRAISE FOR "), _c('em', [_vm._v("THE DIVORCE OF HENRY VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_vm._v("“Catherine Fletcher simply tells a cracking story well, in plenty of detail with clarity and insight . . . Her protagonists are never anything but true to their selves and Fletcher richly deserves the title of historian.”")]), _vm._v(" "), _c('p', {
    staticClass: "Textr"
  }, [_vm._v("—Sarah Vine, "), _c('em', [_vm._v("London Times")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_vm._v("“Fletcher’s glittering debut . . . drawing on the unexplored riches of Italian Renaissance archives, enlarges the [well-known story] and to magnificent effect.”")]), _vm._v(" "), _c('p', {
    staticClass: "Textr"
  }, [_vm._v("—Miranda Seymour, "), _c('em', [_vm._v("Sunday Times")]), _vm._v(" (London)")]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_vm._v("“A marvel of close-up detective work, with the main players, in addition to those on the English side, being the Emperor Charles V (Catherine’s nephew), the king of France and Pope Clement VII . . . And we are in the thick of it from the word ‘go,’ with lots of nasty backbiting.”")]), _vm._v(" "), _c('p', {
    staticClass: "Textr"
  }, [_vm._v("—Duncan Fallowell, "), _c('em', [_vm._v("Daily Express")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_vm._v("“The greatest joy of this splendid book is that it dwells on context. You’ll learn a great deal about why the squabbles between Charles V and the king of France made Italian and papal politics such a muddle. You’ll emerge with a keener sense of why the dynastic priorities of Henry VIII (‘a mid-ranking northern monarch, a player on the European stage but far from the star of the show’) managed to cause such a fuss. With any luck you’ll switch off your TV and rely instead on the hard work of experts who can write very well.”")]), _vm._v(" "), _c('p', {
    staticClass: "Textr"
  }, [_vm._v("—Jonathan Wright, "), _c('em', [_vm._v("The Herald")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_vm._v("“Catherine Fletcher’s ["), _c('em', [_vm._v("The Divorce of Henry VIII")]), _vm._v("] is beautifully written and offers a clear and accessible account of a neglected figure in Tudor and Papal politics. Her study of Gregorio Casali’s career reveals unexpected links between the worlds of the court, business and the law in London and Rome and offers a fascinating account of how patronage and diplomacy worked in sixteenth-century "), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v("Europe. It is thoroughly researched and carefully nuanced, providing not merely a gripping tale of Henry VIII’s campaign for an annulment of his first marriage, but scholarly insights into the nature of personal politics in the Renaissance. It will find its way into the collection not only of the enthusiast of the period, but the student and the professional historian alike.”")]), _vm._v(" "), _c('p', {
    staticClass: "Textr"
  }, [_vm._v("—Glenn Richardson, Reader in Early-Modern History, Saint Mary’s University College London")]), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('p', {
    staticClass: "Fm-Title"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('a', {
    attrs: {
      "id": "tit"
    }
  }, [_c('strong', [_vm._v("THE DIVORCE"), _c('br'), _vm._v(" OF HENRY VIII")])])]), _c('a', {
    attrs: {
      "id": "tit"
    }
  }, [_c('p', {
    staticClass: "Fm-SubTitle"
  }, [_c('strong', [_vm._v("The Untold Story from"), _c('br'), _vm._v(" Inside the Vatican")])]), _vm._v(" "), _c('p', {
    staticClass: "Fm-Author"
  }, [_c('em', [_vm._v("Catherine Fletcher")])]), _vm._v(" "), _c('p', {
    staticClass: "imagep"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/pub.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "break"
  })]), _c('p', {
    staticStyle: {
      "margin-top": "3.0em",
      "text-align": "justify"
    },
    attrs: {
      "id": "copno"
    }
  }, [_c('a', {
    attrs: {
      "id": "tit"
    }
  }, [_vm._v("The author and publisher have provided this e-book to you for your personal use only. You may not make this e-book publicly available in any way. "), _c('strong', [_vm._v("Copyright infringement is against the law. If you believe the copy of this e-book you are reading infringes on the author’s copyright, please notify the publisher at: ")])]), _c('strong', [_c('a', {
    attrs: {
      "href": "http://us.macmillanusa.com/piracy",
      "target": "_blank"
    }
  }, [_vm._v("us.macmillanusa.com/piracy")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('p', {
    staticClass: "Dedication"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('a', {
    attrs: {
      "id": "ded"
    }
  }, [_vm._v("For Mark")])]), _c('a', {
    attrs: {
      "id": "ded"
    }
  }, [_c('p', {
    staticClass: "break"
  })]), _c('p', {
    staticClass: "PrelimTitle"
  }, [_c('a', {
    attrs: {
      "id": "ded"
    }
  }), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "id": "toc"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "toc"
    }
  }), _c('p', {
    staticClass: "contents-text"
  }, [_c('a', {
    attrs: {
      "id": "toc"
    }
  }), _c('a', {
    attrs: {
      "href": "#/html/9780230341517_01_prexiv#loi"
    }
  }, [_c('em', [_vm._v("Illustrations")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-text"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780230341517_01_prexiv#ei1"
    }
  }, [_c('em', [_vm._v("Europe in 1527")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-text"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780230341517_01_prexiv#tcf"
    }
  }, [_c('em', [_vm._v("The Casali Family")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-text"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780230341517_01_prexiv#pre"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-textt"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780230341517_02_ch01"
    }
  }, [_c('span', {
    staticClass: "ClassTitle"
  }, [_c('strong', [_vm._v("1")])]), _vm._v("The King in Love and the Pope Besieged")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-textc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780230341517_03_ch02"
    }
  }, [_c('span', {
    staticClass: "ClassTitle"
  }, [_c('strong', [_vm._v("2")])]), _vm._v("How to Bribe a Cardinal (Part One)")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-textc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230341517_04_ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ClassTitle"
  }, [_c('strong', [_vm._v("3")])]), _vm._v("A Short Tale of Kidnapping")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-textc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230341517_05_ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ClassTitle"
  }, [_c('strong', [_vm._v("4")])]), _vm._v("Cardinal Campeggio Has Gout")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-textc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230341517_06_ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ClassTitle"
  }, [_c('strong', [_vm._v("5")])]), _vm._v("The Vicar of Hell in Rome")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-textc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230341517_07_ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ClassTitle"
  }, [_c('strong', [_vm._v("6")])]), _vm._v("Neither Fair nor Foul Will Serve")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-textc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230341517_08_ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ClassTitle"
  }, [_c('strong', [_vm._v("7")])]), _vm._v("Livia Pallavicino, Heiress")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-textc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230341517_09_ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ClassTitle"
  }, [_c('strong', [_vm._v("8")])]), _vm._v("The Fall of Cardinal Wolsey")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-textc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230341517_10_ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ClassTitle"
  }, [_c('strong', [_vm._v("9")])]), _vm._v("A Coronation and a Wedding")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-textc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230341517_11_ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ClassTitle"
  }, [_c('strong', [_vm._v("10")])]), _vm._v("The Scholar Croke Cries Foul")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-textc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230341517_12_ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ClassTitle"
  }, [_c('strong', [_vm._v("11")])]), _vm._v("The Daily Frauds of the Brothers Casali")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-textc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230341517_13_ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ClassTitle"
  }, [_c('strong', [_vm._v("12")])]), _vm._v("The Custom of England")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-textc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230341517_14_ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ClassTitle"
  }, [_c('strong', [_vm._v("13")])]), _vm._v("Murder in Naples")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-textc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230341517_15_ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ClassTitle"
  }, [_c('strong', [_vm._v("14")])]), _vm._v("How to Bribe a Cardinal (Part Two)")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-textc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230341517_16_ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ClassTitle"
  }, [_c('strong', [_vm._v("15")])]), _vm._v("The Break with Rome")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-textc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230341517_17_ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ClassTitle"
  }, [_c('strong', [_vm._v("16")])]), _vm._v("The Ingratitude of Princes")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-textc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230341517_18_ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ClassTitle"
  }, [_c('strong', [_vm._v("17")])]), _vm._v("A Mother’s Tears")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-textc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230341517_19_epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-textc2t"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230341517_20_ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-text"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230341517_21_not",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-text"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230341517_22_bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-text"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230341517_23_ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('p', {
    staticClass: "PrelimTitle"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "loi"
    }
  }, [_vm._v("ILLUSTRATIONS")])]), _c('a', {
    attrs: {
      "id": "loi"
    }
  }, [_c('p', {
    staticClass: "illustrations-Htext"
  }, [_c('strong', [_vm._v("Map and family tree")])])]), _c('p', {
    staticClass: "illustrations-text"
  }, [_c('a', {
    attrs: {
      "id": "loi"
    }
  }), _c('a', {
    attrs: {
      "href": "#/html/9780230341517_01_prexiv#ei1"
    }
  }, [_c('span', {
    staticClass: "ClassTitle"
  }, [_vm._v("1.")]), _vm._v("Map of Europe in 1527 © 2011 John Bloxam for Upstream Ltd.")])]), _vm._v(" "), _c('p', {
    staticClass: "illustrations-text"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780230341517_01_prexiv#tcf"
    }
  }, [_c('span', {
    staticClass: "ClassTitle"
  }, [_vm._v("2.")]), _vm._v("The Casali Family tree.")])]), _vm._v(" "), _c('p', {
    staticClass: "illustrations-Htext"
  }, [_c('strong', [_vm._v("Illustration section")])]), _vm._v(" "), _c('p', {
    staticClass: "illustrations-text"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230341517_12_ch11#p1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ClassTitle"
  }, [_vm._v("1.")]), _c('em', [_vm._v("Charles V with his English Water-hound")]), _vm._v(", Jakob Seisenegger (1532) © Kunsthistorisches Museum, Vienna.")])]), _vm._v(" "), _c('p', {
    staticClass: "illustrations-text"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230341517_12_ch11#p2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ClassTitle"
  }, [_vm._v("2.")]), _c('em', [_vm._v("The Sack of Rome")]), _vm._v(", unknown Netherlandish artist ("), _c('em', [_vm._v("c")]), _vm._v(". 1527) © Wellcome Library, London.")])]), _vm._v(" "), _c('p', {
    staticClass: "illustrations-text"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230341517_12_ch11#p3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ClassTitle"
  }, [_vm._v("3.")]), _c('em', [_vm._v("Henry VIII")]), _vm._v(", Lucas Horenbout ("), _c('em', [_vm._v("c")]), _vm._v(". 1526–27). The Royal Collection © 2011 Her Majesty Queen Elizabeth II.")])]), _vm._v(" "), _c('p', {
    staticClass: "illustrations-text"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230341517_12_ch11#p4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ClassTitle"
  }, [_vm._v("4.")]), _c('em', [_vm._v("Catherine of Aragon")]), _vm._v(", attr. Lucas Horenbout ("), _c('em', [_vm._v("c")]), _vm._v(". 1525) © National Portrait Gallery, London.")])]), _vm._v(" "), _c('p', {
    staticClass: "illustrations-text"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230341517_12_ch11#p5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ClassTitle"
  }, [_vm._v("5.")]), _c('em', [_vm._v("Pope Clement VII")]), _vm._v(", workshop of Sebastiano del Piombo ("), _c('em', [_vm._v("c")]), _vm._v(". 1531–32) © Kunsthistorisches Museum, Vienna.")])]), _vm._v(" "), _c('p', {
    staticClass: "illustrations-text"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230341517_12_ch11#p6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ClassTitle"
  }, [_vm._v("6.")]), _c('em', [_vm._v("Portrait of Ferry Carondelet with his Secretaries")]), _vm._v(", Sebastiano del Piombo ("), _c('em', [_vm._v("c")]), _vm._v(". 1510–12) © Museo Thyssen-Bornemisza, Madrid.")])]), _vm._v(" "), _c('p', {
    staticClass: "illustrations-text"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230341517_12_ch11#p7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ClassTitle"
  }, [_vm._v("7.")]), _c('em', [_vm._v("Anne Boleyn")]), _vm._v(", unknown artist (late sixteenth century) © National Portrait Gallery, London.")])]), _vm._v(" "), _c('p', {
    staticClass: "illustrations-text"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230341517_12_ch11#p8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ClassTitle"
  }, [_vm._v("8.")]), _vm._v("The Rocca Pallavicino-Casali, Monticelli d’Ongina. Photo © author.")])]), _vm._v(" "), _c('p', {
    staticClass: "illustrations-text"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230341517_12_ch11#p9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ClassTitle"
  }, [_vm._v("9.")]), _c('em', [_vm._v("The Mystical Marriage of Saint Catherine")]), _vm._v(", Filippino Lippi (1501), Chiesa di San Domenico, Bologna © 2011: Photo Scala Florence/Luciano Romano/ Fondo Edifici di Culto—Min. dell’Interno.")])]), _vm._v(" "), _c('p', {
    staticClass: "illustrations-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230341517_12_ch11#p10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ClassTitle"
  }, [_vm._v("10.")]), _c('em', [_vm._v("The Procession of Pope Clement VII and the Emperor Charles V after the Coronation at Bologna")]), _vm._v(", Nicolaus Hogenberg ("), _c('em', [_vm._v("c")]), _vm._v(". 1532) © The British Library Board; shelfmark 144.g.3 (1.).")]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "ei1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/map.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "ei1"
    }
  }), _c('p', {
    staticClass: "imagen"
  }, [_c('a', {
    attrs: {
      "id": "ei1"
    }
  }), _c('a', {
    attrs: {
      "id": "tcf"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/map2.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "tcf"
    }
  }, [_c('p', {
    staticClass: "break"
  })]), _c('p', {
    staticClass: "PrelimTitle"
  }, [_c('a', {
    attrs: {
      "id": "tcf"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "pre"
    }
  }, [_vm._v("PREFACE")])]), _c('a', {
    attrs: {
      "id": "pre"
    }
  }, [_c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE DIVORCE OF HENRY VIII")]), _vm._v(" from Catherine of Aragon is one of those great events of history. You probably know the story. Henry and Catherine have no sons, and Henry comes to believe that this is God’s punishment for marrying his brother’s widow. Henry falls in love with Anne Boleyn. He decides to have his marriage annulled, but the Pope refuses. Henry declares himself head of the Church of England, breaks with Rome and marries Anne. In fifty words or so, that is the famous tale.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("On the other hand, you have probably never heard of Gregorio Casali. Which is strange, because for the six years it took Henry to divorce Catherine, he was our man in Rome, the resident diplomat looking after the king’s “great matter” at the papal court. He was one of the few, in fact, who saw the affair through from start to finish, although before the end of his short life Casali would have reason to curse the “ingratitude of princes.” For his loyalty to Henry, he said, he had paid a high price.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("Casali enjoys a brief mention in Shakespeare and Fletcher’s "), _c('em', [_vm._v("Henry VIII")]), _vm._v(", misspelt as “Gregory de Cassado,” though it is surely him. And the fleeting notoriety of a reference in Shakespeare, albeit in a minor work, is not something many Italian noblemen of the period merit. Beyond that, he rarely escapes the footnotes. How is it that someone so close to something so great can be so nearly lost to history?")])]), _c('p', {
    staticClass: "TextInd"
  }, [_c('a', {
    attrs: {
      "id": "pre"
    }
  }, [_vm._v("When I first came across Casali and his role in English diplomacy, I was working for the BBC in Westminster. When I had time on my hands, I used to watch people doing politics. Not, usually, in the House of Commons, but in coffee bars, on the street or waiting to go into the TV studios. My colleagues and I got to know who drank in which bar, and we speculated why. After I’d ")]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v("been around a few years, people occasionally told me stories that they hoped I’d pass on. Everyone knew that the important business rarely happened in official meetings. For some, it happened in the mythical corridors of power, for others in the mystical smoke-filled rooms.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("And so, when I read those occasional references to Casali in the standard works of Tudor history, I wondered what he had done from day to day. How did he, and the people around him, do their politics, their diplomacy? Where did they do it, and when? What were the rules of the game? One particular thing intrigued me. Casali was an Italian. How could an Italian be ambassador to the King of England? If, for much of what happened in the world of diplomacy five hundred years ago, I could find at least a superficial parallel in the present, I could not find one for that.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("Not quite ten years ago, I decided to try and track down Gregorio Casali, his life and work. Internet searches turned up an attorney-at-law in Massachusetts. I tried libraries: surely, the man who had spent six years of his life handling Henry VIII’s divorce from Catherine of Aragon would be the subject, if not of a book, then at least of an article or two. But no. As I said, it is strange that someone apparently so pivotal could be so lost from history.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("The obvious explanation for that loss would be that Casali’s story isn’t worth the telling. But a little bit of investigation convinced me that wasn’t true. Gregorio Casali was a man who navigated what the great Renaissance thinker Erasmus called the “turbulent waves of diplomacy,” amid tumultuous times for Europe."), _c('span', {
    attrs: {
      "href": "#/html/9780230341517_21_not#pre_1",
      "id": "pre-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("1")])]), _vm._v(" His story brings great events of history to life. It is, however, as much an Italian story as an English one. Through Casali’s eyes we see England from the outside: from Rome, from Italy, from Europe. There, Henry VIII is not the caricature fat tyrant, nor yet the virtuous Renaissance prince, but a mid-ranking northern monarch, a player on the European stage but far from the star of the show. Reading Casali’s letters, we learn much about how the diplomacy of Henry’s divorce worked from day to day, and about how to make a fortune (or try to) by throwing your lot in with a foreign power. His tale tells us about family values, and all sorts of things about living in sixteenth-century Europe: how to get from A to B, how to make a present, how to bribe a cardinal, when to go out in disguise and why it was a good idea to have a secretary who knew the local courtesans. We learn about "), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v("kidnapping, spying, deciphering coded letters and other dirty tricks. And about the importance of being magnificent. Our man in Rome was good at that.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("Gregorio Casali was born around the year 1500 in Rome—a Rome ruled by the infamous Pope Alexander VI, Rodrigo Borgia. The Borgia papacy would become a byword for corruption, murder and tyranny: everything that, for reformers, was wrong with the Church. And our man in Rome was a child of war. Renaissance Italy might have been home to Leonardo and Michelangelo, but it was a land of terror and conflict too. In 1494, Charles VIII, King of France, had marched his armies into Italy, and the Italian peninsula had become the setting for a European war that would last for decades, between the great rival powers France and the Holy Roman Empire. England allied with one or other of them—usually, but not always, the Empire. The French were long-time enemies. It was hard for the English to make a direct impact in distant Italy, but they could provide a northern distraction for troops who would otherwise be engaged in Italian conflicts or supply much-needed cash to their allies’ coffers.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("In 1503, Pope Alexander VI died. His successor, Pius III, the compromise candidate, ruled for a bare four weeks, to be followed by Pope Julius II of the Italian della Rovere family. Aptly known as the warrior pope, Julius took up arms to secure the papacy’s territorial possessions in central Italy, the swathe of land known as the Papal States, stretching north from Rome, past Perugia and over to Ravenna on the Adriatic coast. In 1506, he and his army marched on Bologna and expelled its ruling clan, the Bentivoglio, re-establishing papal dominion over the city. But as pope after pope conducted himself more like secular prince than Vicar of Christ, and as each papal military campaign demanded more resources from the Christians of Europe, calls for religious reform grew. To subsidise their enterprises, the popes sold “indulgences,” discounting time in Purgatory in return for donations to the Church. One notable case of indulgence-peddling in Germany, during the reign of Pope Leo X de’ Medici, prompted particular outrage. In 1517, in protest at such abuse of believers, a young Augustinian monk, Martin Luther, nailed his ninety-five theses to the Wittenberg church door. With an eye to their own wealth, and with few qualms about curtailing Church influence, some German princes "), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _vm._v("were prepared to tolerate Luther and his ideas, though when peasants and townspeople tied the new religion to demands for social reform, their revolts were soon suppressed. These new ideas were known in England too. Many of Henry VIII’s counselors had studied in Europe, but the suggestion that their king, within a few years, might join the Lutheran princes and break with Rome would have been preposterous then. After all, in 1521 Henry had written a book "), _c('em', [_vm._v("against")]), _vm._v(" Luther. His defense of the seven sacraments had been presented to the Pope, and in return the king had received the title “Defender of the Faith,” maintained by English monarchs to this day.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("As Gregorio Casali made his way into the English diplomatic service in the 1520s, France, ruled by King Francis I, was still at war with the Holy Roman Empire—a conglomerate of the German lands, Austria and, by a quirk of inheritance, Spain, too—ruled by the Habsburg dynasty in the person of Charles V (Plate 1). In 1525, Charles’s troops had captured Francis at the Battle of Pavia, and Francis had freed himself only by handing over his sons as hostages. But if Charles was heading for victory on the western front, he had problems in the east. The Empire was also at war with the Turks, whose sultan Suleiman the Magnificent had established himself as one of Europe’s military giants, conquering Hungary, Rhodes and swathes of north Africa. For opponents of Habsburg power, Suleiman was undoubtedly a useful ally, despite papal injunctions that the Christian princes should stick together.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("So, a Protestant challenge in the north; the Catholic princes at war; the French princes imprisoned; the Ottoman Turks under Suleiman, pushing ever further west: this was the world of our man in Rome.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("To write Casali’s story has been a long and intriguing piece of historical detective work. From the usual sources in London, I began with the story of the divorce. (Technically, Henry was not seeking a divorce but a declaration that his marriage was invalid; however, his contemporaries used the word, and I see no reason to avoid it."), _c('span', {
    attrs: {
      "href": "#/html/9780230341517_21_not#pre_2",
      "id": "pre-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("2")])]), _vm._v(") But although the London letters—those written by Casali and his colleagues to Henry VIII, Wolsey and others at court—gave me scraps of detail about his life, much was still missing. Next, I went to Bologna, Casali’s home town. His family palazzo is long demolished, courtesy of a nineteenth-century road-widening scheme, but in the archives I found detail of his business dealings, and those of his family, and in old "), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _vm._v("chronicles of the city passing references that linked him to important political figures in Rome. I saw his family chapel and his memorial in the Church of San Domenico. One chilly December day, I took a trip to the small northern town of Parma to see if I could find any news of his wife, and I found a little. My big stroke of luck, though, came a few stops up the railway line in Piacenza. I had gone there on my way to see the Rocca Pallavicino-Casali, a castle once owned by Gregorio’s descendants, in the village of Monticelli d’Ongina near the River Po. I dropped in to the State Archive to ask whether they had any documents relating to Casali. It was a long shot. Nothing was listed in the archive guide. But, the archivist told me, the Casali family still lived in Piacenza. In fact, they had their own private archive: boxes of papers documenting births, marriages and deaths dating back more than five hundred years.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("Next stop was Rome and the Vatican. More details, more pieces in the jigsaw. Especially marvelous were the records of Cardinal Accolti’s trial for abuse of power, where I found Casali’s secretary giving evidence of his master’s attempts at bribery. The cardinal’s letters (in Florence) were remarkable too. Meanwhile, a researcher at Columbia University had discovered an entirely new set of Casali letters—intercepted by Imperial spies and filed in Vienna. The dispatches of the Mantuan diplomats in Rome added glorious color to the story of Henry’s divorce. And more details kept turning up: Casali’s brother appears as a character in a sixteenth-century Venetian best-seller; portrait medals of his uncle survive in the British Museum and the Victoria and Albert Museum. I began to piece together the details of a short but intensely complex life and a family network that stretched from Constantinople in the east to London in the north. There are still gaps: no portrait of Casali survives, for example, although his code name, Capo Pelato—the bald man—strongly hints at a distinguishing feature."), _c('span', {
    attrs: {
      "href": "#/html/9780230341517_21_not#pre_3",
      "id": "pre-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("The historians who come across Gregorio Casali have, usually, taken his letters and scavenged from them the facts of Henry’s divorce. He has become a faceless source of dates and detail. But Casali—the real Casali—did not exist for the convenience of Tudor history students. He had his own interests. Sometimes he had an axe to grind. He certainly liked to make a good impression. At Henry’s court, and at courts throughout Europe and beyond, "), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _vm._v("appearances counted for a lot. Whenever Gregorio wrote to England, he did so with that in mind. So, can we rely on him? Did he sometimes bend the truth in order to tell people what they wanted to hear? He was prepared to lie and deceive for Henry; did he ever lie to his masters? How far did he flatter, embellish and spin? In Graham Greene’s novel "), _c('em', [_vm._v("Our Man in Havana")]), _vm._v(", the hero Wormold, a vacuum-cleaner salesman in need of money, finds an opportunity to pay his daughter’s finishing-school fees by taking the job of British agent in Cuba and then faking a series of espionage reports. Was Casali doing the same: stringing the English along for the sake of his daughter’s dowry? Some people thought so. Gregorio’s fellow agent Richard Croke accused the Casali family of sabotage. Was he right?")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("We shall see. This, then, is the story of our man in Rome: a man who was not himself great, but who knew the great men of history. And a man who found himself, quite unexpectedly, at the heart of a king’s “great matter.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c0bfad3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780230341517_01_prexiv.vue
// module id = 57
// module chunks = 0